// extracted by mini-css-extract-plugin
export default {"marker":"markers_marker__pOkEE"};